import { catchError } from 'rxjs/operators';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractHttpService } from './http-abstract.service';
import { ConfigDto, DynamicField, DynamicLink, FlushResponse, SaveTextResponseDto, SelfRegImageDto, ServiceSelectionDto } from './dtos';
import { Injectable } from '@angular/core';
import { DateNP } from 'datenp';

@Injectable({providedIn: 'root'})
export class HttpSubmissionService extends AbstractHttpService {
	constructor(http: HttpClient) {
        super(http);
    }

	private getUri(serviceSelection: ServiceSelectionDto): string {
		return `/${serviceSelection.idNumber}/${serviceSelection.sectionId}`;
	}

    getDynamicFieldConfig(serviceSelection: ServiceSelectionDto): Observable<ConfigDto> {
        return super.getWithOtp(this.getUri(serviceSelection) + "/dynamiclink", serviceSelection.otp);
    }

	getSavedImage(serviceSelection: ServiceSelectionDto, imageId: number): Observable<SelfRegImageDto> {
        return super.getWithOtp(this.getUri(serviceSelection) + `/getimage/${imageId}`, serviceSelection.otp);
    }

	saveText(serviceSelection: ServiceSelectionDto, dynamicLink: DynamicLink): Observable<SaveTextResponseDto> {

		const cardId = dynamicLink.cards[0].id;
		const map =  Object.assign({}, ...dynamicLink.cards[0].fields.map(item => {
			if ( item.inputField === 'date' ) {
				console.log('Field id [' + item.id + '] - field [' + item.field + '] has value [' + JSON.stringify(item.formControl.value) + ']');
				if (item.formControl.value === null) {
					return null;
				} else if (typeof item.formControl.value === 'string') {
					return ({[item.propertyName]: item.formControl.value});
				} else {
					const d = new Date();
					if (-1 === item.formControl.value.year) {
						return null;
					}
					d.setFullYear(item.formControl.value.year);
					d.setMonth(item.formControl.value.month - 1);
					d.setDate(item.formControl.value.day);
					return ({[item.propertyName]: d.toISOString()});
				}
				

				// const d = new DateNP(item.formControl.value.year + "-" + item.formControl.value.month + "-" + item.formControl.value.day).toAD();
				// const convertedDate = new Date();
				// convertedDate.setFullYear(d.year, d.month, d.day);
				// return ({[item.propertyName]: convertedDate.toISOString()});
			} else {
				return ({[item.propertyName]: item.formControl.value});
			}
		}));

		return super.postWithOtp(this.getUri(serviceSelection) + `/save/text/${cardId}`, map, serviceSelection.otp);
	}

	saveImage(serviceSelection: ServiceSelectionDto, cardId: number, field: DynamicField): Observable<any> {
		const data = new FormData();
        data.append("file", field.formControl.value);
		if (field.imageId) {
			return super.postWithOtp(this.getUri(serviceSelection) + `/save/image/${cardId}/${field.id}/${field.imageId}`, data, serviceSelection.otp);
		} else {
			return super.postWithOtp(this.getUri(serviceSelection) + `/save/image/${cardId}/${field.id}`, data, serviceSelection.otp);
		}
		
	}

	flush(serviceSelection: ServiceSelectionDto): Observable<FlushResponse> {
        return super.getWithOtp(this.getUri(serviceSelection) + "/flush", serviceSelection.otp);
    }

}